import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, AlertCircle } from 'lucide-react';

const variants = {
  success: {
    icon: <CheckCircle className="w-5 h-5" />,
    className: "bg-green-100 text-green-800 dark:bg-green-800/20 dark:text-green-400"
  },
  warning: {
    icon: <AlertCircle className="w-5 h-5" />,
    className: "bg-yellow-100 text-yellow-800 dark:bg-yellow-800/20 dark:text-yellow-400"
  },
  error: {
    icon: <AlertCircle className="w-5 h-5" />,
    className: "bg-red-100 text-red-800 dark:bg-red-800/20 dark:text-red-400"
  }
};

const Notification = ({ message, type = 'success', index = 0 }) => {
  const topOffset = `${index * 4 + 1}rem`; // 4rem height + 1rem gap
  
  // Fallback to success variant if type is not found
  const variant = variants[type] || variants.success;

  return (
    <motion.div
      initial={{ opacity: 0, y: -100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      style={{ top: topOffset }}
      className={`fixed right-4 p-4 rounded-lg shadow-lg flex items-center gap-3 z-50 ${variant.className}`}
    >
      {variant.icon}
      <p className="font-medium">{message}</p>
    </motion.div>
  );
};

export default Notification;